/* eslint-disable */
import React from "react";
const Datagrid = () => <div>Datagrid Demo</div>;
export default Datagrid;
